import React, { useState } from "react";
import { useNavigate } from "react-router-dom"; 
import { auth } from "./firebase"; 
import { signInWithEmailAndPassword } from "firebase/auth"; 
import { FaEye, FaEyeSlash } from "react-icons/fa";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false); 
  const navigate = useNavigate(); 

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      await signInWithEmailAndPassword(auth, email, password);
      alert("✅ Login Successful!");
      navigate("/"); 
    } catch (error) {
      setError(getFriendlyError(error.message)); 
    } finally {
      setLoading(false);
    }
  };

  const getFriendlyError = (message) => {
    if (message.includes("auth/user-not-found")) return "❌ Geen gebruiker gevonden met dit e-mailadres.";
    if (message.includes("auth/wrong-password")) return "❌ Onjuist wachtwoord.";
    if (message.includes("auth/invalid-email")) return "❌ Ongeldig e-mailformaat.";
    if (message.includes("auth/too-many-requests")) return "🚫 Te veel inlogpogingen. Probeer het later opnieuw.";
    return "⚠️ Inloggen mislukt. Probeer het opnieuw.";
  };
  

  return (
    <div className="container">
      <div className="login-container">
        <div className="login-box">
          <h2>Log in</h2>
          {error && <p className="error-message">{error}</p>}
          <form onSubmit={handleLogin}>
            <label>Email</label>
            <input 
              type="email" 
              value={email} 
              onChange={(e) => setEmail(e.target.value)} 
              required 
              placeholder="you@example.com"
            />

            <label>Password</label>
            <div className="password-container">
              <input 
                type={showPassword ? "text" : "password"} 
                value={password} 
                onChange={(e) => setPassword(e.target.value)} 
                required 
                placeholder="Enter your password"
              />
                <span
                className="togglePassword"
                onClick={() => setShowPassword(!showPassword)}
                >
                {showPassword ? (
                <FaEyeSlash className="toggleIcon" />
                ) : (
                <FaEye className="toggleIcon" />
                )}
                </span>
            </div>

            <button type="submit" disabled={loading || !email || !password}>
              {loading ? "Logging in..." : "Log in"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Login;
